import React, { useState, useEffect, useRef } from 'react';
import { Check, PlusCircle, MapPin, Cpu, Search } from 'lucide-react';

const EngineeringCollegeSearch = ({ formData, setFormData }) => {
  const [query, setQuery] = useState(formData.collegeName || '');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Pure list of MP Engineering Colleges
  const engineeringColleges = [
    { name: "MANIT Bhopal (NIT)", city: "Bhopal" },
    { name: "IIT Indore", city: "Indore" },
    { name: "SGSITS Indore", city: "Indore" },
    { name: "IET DAVV", city: "Indore" },
    { name: "Jabalpur Engineering College (JEC)", city: "Jabalpur" },
    { name: "MITS Gwalior", city: "Gwalior" },
    { name: "LNCT Group of Colleges", city: "Bhopal" },
    { name: "Oriental Institute of Science & Tech (OIST)", city: "Bhopal" },
    { name: "UIT RGPV", city: "Bhopal" },
    { name: "IIIT Bhopal", city: "Bhopal" },
    { name: "Medi-Caps University", city: "Indore" },
    { name: "SISTec (Sagar Institute)", city: "Bhopal" },
    { name: "Technocrats Institute (TIT)", city: "Bhopal" },
    { name: "Acropolis Institute of Tech", city: "Indore" },
    { name: "IPS Academy", city: "Indore" },
    { name: "IES College", city: "Bhopal" },
    { name: "VNS Institute", city: "Bhopal" }
  ];

  const filtered = query === '' 
    ? [] 
    : engineeringColleges.filter(c => 
        c.name.toLowerCase().includes(query.toLowerCase()) || 
        c.city.toLowerCase().includes(query.toLowerCase())
      );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (name) => {
    setQuery(name);
    setFormData({ ...formData, collegeName: name, isCollegeAdded: true });
    setIsOpen(false);
  };

  return (
    <div className="space-y-3 relative" ref={dropdownRef}>
      <label className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] block ml-1">
        Engineering Campus
      </label>
      
      <div className="relative group">
        <div className="absolute left-4 top-1/2 -translate-y-1/2 text-blue-600">
          <Search size={18} />
        </div>
        
        <input 
          type="text" 
          placeholder="Search engineering colleges..."
          value={query}
          onFocus={() => setIsOpen(true)}
          onChange={(e) => {
            setQuery(e.target.value);
            setIsOpen(true);
            setFormData({ ...formData, collegeName: e.target.value, isCollegeAdded: e.target.value.length > 2 });
          }}
          className="w-full pl-12 pr-4 py-4 bg-slate-50 border-2 border-transparent focus:border-blue-600/20 focus:bg-white rounded-2xl text-sm font-bold text-slate-800 transition-all outline-none"
        />

        {isOpen && query.length > 0 && (
          <div className="absolute z-50 w-full mt-2 bg-white border border-slate-100 rounded-[2rem] shadow-2xl shadow-blue-900/15 max-h-[280px] overflow-y-auto animate-in fade-in slide-in-from-top-2 duration-300">
            <div className="p-2 space-y-1">
              
              {filtered.length > 0 ? (
                filtered.map((college, i) => (
                  <button
                    key={i}
                    onClick={() => handleSelect(college.name)}
                    className="w-full flex items-center justify-between p-4 text-left hover:bg-blue-50 rounded-2xl transition-all group"
                  >
                    <div className="flex flex-col">
                      <span className="text-xs font-black text-slate-800 group-hover:text-blue-700 leading-tight">
                        {college.name}
                      </span>
                      <div className="flex items-center text-[10px] font-bold text-slate-400 uppercase tracking-tighter mt-1">
                        <MapPin size={10} className="mr-1 opacity-70" />
                        {college.city}
                      </div>
                    </div>
                    {formData.collegeName === college.name && (
                      <div className="bg-blue-600 p-1 rounded-full text-white">
                        <Check size={12} strokeWidth={3} />
                      </div>
                    )}
                  </button>
                ))
              ) : (
                <div className="p-6 text-center text-slate-400">
                  <p className="text-[10px] font-bold italic">No matches found in MP database</p>
                </div>
              )}

              {/* Add New College Action */}
              <button
                onClick={() => handleSelect(query)}
                className="w-full flex items-center space-x-3 p-4 text-left bg-slate-900 text-white rounded-2xl shadow-lg mt-2 transition-transform active:scale-95 hover:bg-blue-600"
              >
                <PlusCircle size={18} className="text-blue-400" />
                <div className="flex-1">
                  <p className="text-[10px] font-black uppercase tracking-widest leading-none mb-1">Add to CampusIra</p>
                  <p className="text-[9px] opacity-60 font-medium">Use "{query}" as your college</p>
                </div>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EngineeringCollegeSearch;